import React from 'react';
import classNames from 'classnames/bind';
import { DimmedHeader, DimmedContent, DimmedFooter } from '@/components/CustomTravel/DimmedPopup';
import ServiceForm from '@/components/CustomTravel/ServiceForm';
import useCustomRecommend from '@/hooks/custom/useCustomRecommend';
import { CustomTravelEstimatePopupStep, CustomTravelParamType } from '@/components/CustomTravel/EstimatePopup';
import styles from './SelectLocationForm.module.scss';
import { VisitAreas } from './VisitAreas';
import { GroupByVisitArea } from '@/components/CustomTravel/CustomInit';
import { RecommendCities } from './RecommendCities';
import ConditionalField from '@/components/ServiceFormFields/ConditionalField';
import usePopupHandler from '@/hooks/custom/usePopupHandler';

const cx = classNames.bind(styles);

interface SelectLocationFormProps {
  visitAreas: GroupByVisitArea[];
  externalValues?: any;
  recommendSelectedCount: number;
}

const SelectLocationForm: React.FC<SelectLocationFormProps> = ({
  visitAreas,
  externalValues,
  recommendSelectedCount,
}) => {
  const { handleBack, onSubmitNextStep, currentType } = usePopupHandler();
  const customRecommends = useCustomRecommend();

  const handleSubmit = (values: any) => {
    const destinations = customRecommends?.filter(({ cityCodes }) => {
      if (!cityCodes) return false;

      return values?.destinations?.[cityCodes?.join('-')];
    });

    onSubmitNextStep(
      {
        destinations:
          destinations?.map((destination) => ({
            codes: destination?.cityCodes || [],
            name: destination.name,
          })) || [],
      },
      CustomTravelEstimatePopupStep.SelectDuration,
    );
  };
  return (
    <ServiceForm onSubmit={handleSubmit} externalValues={externalValues}>
      <div className={cx('SelectLocation')} data-event-nlog="imp" data-event-area-code="customtravel.popup.locatioon">
        <DimmedHeader>
          {currentType !== CustomTravelParamType.CHECK_ESTIMATE && (
            <span className={cx('page')}>
              <span className={cx('blind')}>현재</span>
              <b>{'2'}</b>
              <span className={cx('blind')}>전체</span>
              <span>{'5'}</span>
            </span>
          )}
          <span className={cx('title')}>여행지 확인</span>
        </DimmedHeader>
        <DimmedContent>
          <VisitAreas visitAreas={visitAreas} />
          <RecommendCities recommendSelectedCount={recommendSelectedCount} />
        </DimmedContent>
        <DimmedFooter>
          <div className={cx('progress')}>
            <button
              type="button"
              className={cx('prev')}
              onClick={handleBack(CustomTravelEstimatePopupStep.SelectGroupType, { type: currentType })}
              data-event-nlog="click"
              data-event-area-code="cus.selfdestinationbackpage"
            >
              {currentType !== CustomTravelParamType.CHECK_ESTIMATE ? '이전' : '취소'}
            </button>
            <ConditionalField<Record<string, boolean>> targetFieldName="destinations">
              {(destinations) => (
                <button
                  type="submit"
                  className={cx('next')}
                  disabled={
                    !Object.values(destinations || {}).some((isSelect) => !!isSelect) &&
                    visitAreas.length === 1 &&
                    !!customRecommends?.length
                  }
                  data-event-nlog="click"
                  data-event-area-code="cus.selfdestinationnextpage"
                >
                  {currentType !== CustomTravelParamType.CHECK_ESTIMATE ? '다음' : '수정하기'}
                </button>
              )}
            </ConditionalField>
          </div>
        </DimmedFooter>
      </div>
    </ServiceForm>
  );
};

export default SelectLocationForm;
